var exports = {
  "x6": "DiscoveryButton.module__button___M3BReE",
  "td": "DiscoveryButton.module__iconText___M3BReE",
  "yF": "DiscoveryButton.module__iconTextSelected___M3BReE",
};

module.exports = exports;
